export default {
    lifts: [
        {
            'id': 1,
            'name': 'Front Squat'
        },
        {
            'id': 2,
            'name': 'Back Squat'
        },
        {
            'id': 3,
            'name': 'Over Head Squat'
        },
        {
            'id': 4,
            'name': 'Power Clean'
        },
        {
            'id': 5,
            'name': 'Squat Clean'
        },
        {
            'id': 6,
            'name': 'Clean & Jerk'
        },
        {
            'id': 7,
            'name': 'Push Jerk'
        },
        {
            'id': 8,
            'name': 'Split Jerk'
        },
        {
            'id': 9,
            'name': 'Strict Press'
        },
        {
            'id': 10,
            'name': 'Push Press'
        },
        {
            'id': 11,
            'name': 'Bench Press'
        },
        {
            'id': 12,
            'name': 'Dead Lift'
        },
        {
            'id': 13,
            'name': 'Power Snatch'
        },
        {
            'id': 14,
            'name': 'Squat Snatch'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/liftTypes.js